// @flow
import React from 'react';

type Props = {
  title: string,
  value: ?string,
  onChange: (Event) => void
}

const EditAssetRow = (props: Props) => {
  const { title, value, onChange } = props;

  return (
    <div
      style={{
        textAlign: 'left',
        fontSize: '14px',
        fontWeight: '700',
        paddingTop: '10px'
      }}
    >
      { title }
      <textarea
        style={{
          fontSize: '12px',
          width: '380px',
          height: '30px'
        }}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default EditAssetRow;
